// Zrcadlí C# enum Car.DataModel.Enums.InsurerOfferCategoryValues (serializuje se jako číslo).
export const InsurerOfferCategoryValues = {
    Vehicle: 0,      // auto-pojištění
    Gap: 1,          // samostatný GAP
    Assistance: 2,   // asistence
    StockBefore: 3,  // skladové pojištění před předáním vozidla
    StockAfter: 4,   // skladové pojištění při vrácení vozidla
} as const

export type InsurerOfferCategoryValues =
    typeof InsurerOfferCategoryValues[keyof typeof InsurerOfferCategoryValues]

const insurerOfferCategoryNames: Record<InsurerOfferCategoryValues, string> = {
    [InsurerOfferCategoryValues.Vehicle]: 'Pojištění vozidla',
    [InsurerOfferCategoryValues.Gap]: 'GAP',
    [InsurerOfferCategoryValues.Assistance]: 'Asistence',
    [InsurerOfferCategoryValues.StockBefore]: 'Skladové pojištění',
    [InsurerOfferCategoryValues.StockAfter]: 'Skladové pojištění',
}

export function getInsurerOfferCategoryName(category?: InsurerOfferCategoryValues | null): string {
    if (category === undefined || category === null) return ''
    return insurerOfferCategoryNames[category] ?? ''
}
